import { Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { acGetCompanyCustomer } from '../../store/actions';
import { formatCNPJ } from '../../utils';


export default function DashboardStats({
    theme,
    isFiltered,
    filteredCNPJ,
    scoreMetrics,
    currentData,
}) {

    const dispatch = useDispatch()
    const displayCNPJ = formatCNPJ(filteredCNPJ)

    const {
        companyCustomer,
        // isLoadingCompanyCustomer,
        // hasErrorCompanyCustomer,
    } = useSelector(store => store.companyCustomer)

    const StatCard = ({ title, value, filteredSubtitle, color = theme.palette.text.primary }) => (

        <Card elevation={0} sx={{ height: '100%' }}>
            <CardContent sx={{ textAlign: 'left', p: 3 }}>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: '0.875rem', fontWeight: 500 }}
                >
                    {title}
                </Typography>

                { isFiltered &&
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: '0.75rem', mb: 1 }}
                    >
                        { filteredSubtitle }
                    </Typography>
                }

                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 'bold',
                        color: color,
                        fontSize: '2.5rem'
                    }}
                >
                    {scoreMetrics.loading ? (
                        <CircularProgress size={24} />
                    ) : (
                        value?.toLocaleString() || 0
                    )}
                </Typography>
            </CardContent>
        </Card>
    )

    useEffect(() => {

        if (!filteredCNPJ) {
            return
        }

        dispatch(acGetCompanyCustomer(filteredCNPJ))
    }, [ filteredCNPJ ])

    let items = [
        {
            title: "Total de Consultas",
            unfilteredSubtitle: "Número total de consultas de score realizadas",
            filteredSubtitle: "Número total de consultas de score realizadas pelo CNPJ " + displayCNPJ,
            value: currentData.total_queries
        },
        {
            title: "Média do Score",
            unfilteredSubtitle: "Média do score dos seus clientes",
            filteredSubtitle: "Média do score do CNPJ " + displayCNPJ,
            value: Math.round(currentData.avarage_score)
        },
        {
            title: "Score máximo",
            unfilteredSubtitle: "Score máximo dos seus clientes",
            filteredSubtitle: "Score máximo do CNPJ " + displayCNPJ,
            value: currentData.max_score
        },
        {
            title: "Score mínimo",
            unfilteredSubtitle: "Score mínimo dos seus clientes",
            filteredSubtitle: "Score mínimo do CNPJ " + displayCNPJ,
            value: currentData.min_score
        },
    ]

    const lastConsult = companyCustomer && (
        " (Atualizado em: " + new Date(companyCustomer.updatedAt).toLocaleString('pt-BR') + ")"
    )

    if (companyCustomer && filteredCNPJ) {
        items = [
            ...items,
            {
                title: "Score",
                filteredSubtitle: "Score do " + displayCNPJ + lastConsult,
                value: companyCustomer.score
            },
            {
                title: "Porcentagem de Limite Consumido",
                filteredSubtitle:  "Porcentagem de Limite Consumido pelo CNPJ " + displayCNPJ + lastConsult,
                value: companyCustomer.consumed_credit_limit_percentage
            },
            {
                title: "Multiplicador",
                filteredSubtitle: "Multiplicador do CNPJ " + displayCNPJ + lastConsult,
                value: companyCustomer.credit_limit_factor
            },
            {
                title: "Código do Vendedor",
                filteredSubtitle:  "Código do Vendedor do CNPJ " + displayCNPJ + lastConsult,
                value: companyCustomer.seller_code
            },
        ]
    }

    return (
        <Grid container spacing={3}>
            { items.map(({title, filteredSubtitle, unfilteredSubtitle, value }) => (
                <Grid item xs={12} md={3} key={title}>
                    <StatCard
                        title={title}
                        filteredSubtitle={filteredSubtitle}
                        unfilteredSubtitle={unfilteredSubtitle}
                        value={value}
                    />
                </Grid>
            ))}
        </Grid>
    )
}

